import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const signinRoutes = {
  name: 'signin',
  path: 'signin',
  components: {
    default: () => import('./SignIn.vue'),
    brand: () => import('./SignInBrand.vue'),
  },
  meta: {
    i18n,
    authHeader: { titleKey: 'signin.heading', subtitleKey: 'signin.subtitle' },
  },
} satisfies RouteRecordRaw;
